import { ROUTES } from ".";

export const MANAGE_REPORTS_ROUTES = {
  ELIGIBILITY_FILTER: `${ROUTES.MANAGE_REPORTS}/eligibility-filter`,
  GCONTRIBUTION_LIMITS: `${ROUTES.MANAGE_REPORTS}/gcontribution-limit`,
  CONTRIBUTION_LIMITS: `${ROUTES.MANAGE_REPORTS}/contribution-limit`,
  ELIGIBILITY_FORECAST: `${ROUTES.MANAGE_REPORTS}/eligibility-forecast`,
  DELETED_PARTICIPANT: `${ROUTES.MANAGE_REPORTS}/deleted-participant`,
  REHIRE_REPORT: `${ROUTES.MANAGE_REPORTS}/rehire-report`,
  NEW_PARTICIPANT: `${ROUTES.MANAGE_REPORTS}/new-participant`,
  EMPLOYEMENT_STATUS: `${ROUTES.MANAGE_REPORTS}/employement-status`,
  ERROR_COUNT: `${ROUTES.MANAGE_REPORTS}/error-count`,
  CONTRIBUTION_DATA_REPORT: `${ROUTES.MANAGE_REPORTS}/participant-contibution-data-report`,
  PARTICIPANT_UPDATES_REPORT: `${ROUTES.MANAGE_REPORTS}/participant-updates-report`,
  COMPENSATION_HOURS_AND_LOANS: `${ROUTES.MANAGE_REPORTS}/compensation-hours-loans`,
  LOAN_PAYMENT: `${ROUTES.MANAGE_REPORTS}/loan-payment`,
  CONTRIBUTION_FLAGS: `${ROUTES.MANAGE_REPORTS}/contribution-flags`,
  PLAN_ELIGIBILITY_DATA_REPORT: `${ROUTES.MANAGE_REPORTS}/plan-eligibility-data-report`,
  SPONSOR_DETAILS: `${ROUTES.MANAGE_REPORTS}/sponsor-details`,
  PLAN_SUMMARY: `${ROUTES.MANAGE_REPORTS}/plan-summary`,
  LATE_PAYROLL_NOTIFICATIONS: `${ROUTES.MANAGE_REPORTS}/late-payroll-notifications`,
  PERIODIC_CENSUS: `${ROUTES.MANAGE_REPORTS}/periodic-census`,
  PERIODIC_EMPLOYER_CONTRIBUTION_REPORT: `${ROUTES.MANAGE_REPORTS}/periodic-employer-contribution-report`,
  AGGREGATED_REPORT: `${ROUTES.MANAGE_REPORTS}/aggregated-report`,
  RMD_Report: `${ROUTES.MANAGE_REPORTS}/RMD-Report`,
  MISSED_RMD_REPORT: `${ROUTES.MANAGE_REPORTS}/Missed-RMD-Report`,
  FORCE_OUT_REPORT: `${ROUTES.MANAGE_REPORTS}/force-out-report`,
  FORFEITURE_REPORTS: `${ROUTES.MANAGE_REPORTS}/forfeiture-report`,
  PARTICIPANT_STATUS_CHANGE_REPORT: `${ROUTES.MANAGE_REPORTS}/participant-status-change-report`,
  VESTING_REDUCTION_REPORT: `${ROUTES.MANAGE_REPORTS}/vesting-reduction-report`,
  LOAN_REPAYMENT_DETAIL_REPORT: `${ROUTES.MANAGE_REPORTS}/loan-repayment-detail-report`,
  PAYROLL_WORKLOAD_ANTICIPATION_REPORT: `${ROUTES.MANAGE_REPORTS}/payroll-workload-anticipation-report`,
  PLAN_LIST_REPORT: `${ROUTES.MANAGE_REPORTS}/plan-list`,
  PAYROLL_CALENDAR_ENDDATE: `${ROUTES.MANAGE_REPORTS}/payroll-calendar`,
  ENROLLMENT_REVIEW_REPORT: `${ROUTES.MANAGE_REPORTS}/enrollment-review-report`,
  REPORT_316: `${ROUTES.MANAGE_REPORTS}/316-census-report`,
  MAPPER_LIST_REPORT: `${ROUTES.MANAGE_REPORTS}/mapper-list`,
  NON_PAY_PERIOD_REPORT: `${ROUTES.MANAGE_REPORTS}/non-pay-period-report`,
  PAYROLL_FREQUENCY_REPORT: `${ROUTES.MANAGE_REPORTS}/payroll-frequency-report`,
};

export const MANAGE_REPORTS_MENU = [
  {
    label: "Report",
  },
  {
    label: "Eligibility",
    subNav: [
      {
        id: "eligibilityReports",
        label: "Status",
        path: MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "eligibiltyForecast",
        label: "Forecast",
        path: MANAGE_REPORTS_ROUTES.ELIGIBILITY_FORECAST,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "planEligibilityDataReport",
        label: "Plan Eligibility Data Report",
        path: MANAGE_REPORTS_ROUTES.PLAN_ELIGIBILITY_DATA_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "enrollmentReviewReport",
        label: "Enrollment review",
        path: MANAGE_REPORTS_ROUTES.ENROLLMENT_REVIEW_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Vesting",
    subNav: [
      {
        id: "forfeitureReport",
        label: "Forfeiture",
        path: MANAGE_REPORTS_ROUTES.FORFEITURE_REPORTS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "participantStatusChange",
        label: "Participant Status Change",
        path: MANAGE_REPORTS_ROUTES.PARTICIPANT_STATUS_CHANGE_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "vestingReductionReport",
        label: "Vesting Reduction Report",
        path: MANAGE_REPORTS_ROUTES.VESTING_REDUCTION_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Contribution Limits",
    subNav: [
      {
        id: "gContributionLimit",
        label: "402 (G) Limit",
        path: MANAGE_REPORTS_ROUTES.GCONTRIBUTION_LIMITS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "contributionLimit",
        label: "415",
        path: MANAGE_REPORTS_ROUTES.CONTRIBUTION_LIMITS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Participant",
    subNav: [
      {
        id: "deletedParticipant",
        label: "Deleted Status",
        path: MANAGE_REPORTS_ROUTES.DELETED_PARTICIPANT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "compensationHoursLoans",
        label: "Compensation, Hours and Loans",
        path: MANAGE_REPORTS_ROUTES.COMPENSATION_HOURS_AND_LOANS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "participantUpdatesReport",
        label: "Participant Updates",
        path: MANAGE_REPORTS_ROUTES.PARTICIPANT_UPDATES_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "contributionDataReport",
        label: "Participant Contribution Data",
        path: MANAGE_REPORTS_ROUTES.CONTRIBUTION_DATA_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "rehireReport",
        label: "Rehire Report",
        path: MANAGE_REPORTS_ROUTES.REHIRE_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "periodicCensus",
        label: "Periodic Census",
        path: MANAGE_REPORTS_ROUTES.PERIODIC_CENSUS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      // {
      //   id: "newParticipant",
      //   label: "New Participant",
      //   path: MANAGE_REPORTS_ROUTES.NEW_PARTICIPANT,
      //   contentHeader: "Reports",
      //   breadCrumbs: [],
      //   childRoutes: [],
      // },
      {
        id: "316CensusReport",
        label: "Annual Admin Census Report",
        path: MANAGE_REPORTS_ROUTES.REPORT_316,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },

  {
    label: "Employment",
    subNav: [
      {
        id: "employmentStatus",
        label: "Status ",
        path: MANAGE_REPORTS_ROUTES.EMPLOYEMENT_STATUS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Sponsor",
    subNav: [
      {
        id: "sponsorDetails",
        label: "Sponsor Details",
        path: MANAGE_REPORTS_ROUTES.SPONSOR_DETAILS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Payroll",
    subNav: [
      {
        id: "errorCount",
        label: "Error Count ",
        path: MANAGE_REPORTS_ROUTES.ERROR_COUNT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "planSummary",
        label: "Plan Summary",
        path: MANAGE_REPORTS_ROUTES.PLAN_SUMMARY,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "nonPayPeriodReport",
        label: "Non Pay Period Report",
        path: MANAGE_REPORTS_ROUTES.NON_PAY_PERIOD_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Loans",
    path: MANAGE_REPORTS_ROUTES.LOAN_PAYMENT,
    subNav: [
      {
        id: "loanPayment",
        label: "Loan Repayment",
        path: MANAGE_REPORTS_ROUTES.LOAN_PAYMENT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Contribution",
    subNav: [
      {
        id: "contributionFlags",
        label: "Contribution Flags",
        path: MANAGE_REPORTS_ROUTES.CONTRIBUTION_FLAGS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "periodicEmployerContributionReport",
        label: "Periodic Employer Contribution Calculation",
        path: MANAGE_REPORTS_ROUTES.PERIODIC_EMPLOYER_CONTRIBUTION_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Aggregated",
    subNav: [
      {
        id: "aggregatedPeriodicReport",
        label: "Aggregated Summary Report",
        path: MANAGE_REPORTS_ROUTES.AGGREGATED_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Tenant Level Reports",
    subNav: [
      {
        id: "payrollWorkloadAnticipation",
        label: "Payroll workload",
        path: MANAGE_REPORTS_ROUTES.PAYROLL_WORKLOAD_ANTICIPATION_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "planList",
        label: "Plan List",
        path: MANAGE_REPORTS_ROUTES.PLAN_LIST_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "payrollCalendarEnddate",
        label: "Payroll calendar end date",
        path: MANAGE_REPORTS_ROUTES.PAYROLL_CALENDAR_ENDDATE,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "latePayrollNotifications",
        label: "Late Payroll Notifications",
        path: MANAGE_REPORTS_ROUTES.LATE_PAYROLL_NOTIFICATIONS,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "mapperListReport",
        label: "Mapper List Report",
        path: MANAGE_REPORTS_ROUTES.MAPPER_LIST_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "payrollFrequencyReport",
        label: "Payroll Frequency Report",
        path: MANAGE_REPORTS_ROUTES.PAYROLL_FREQUENCY_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },

  {
    label: "RMD ",
    subNav: [
      {
        id: "RMDReport",
        label: "RMD",
        path: MANAGE_REPORTS_ROUTES.RMD_Report,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
      {
        id: "MissedRMDReport",
        label: "MissedRMD",
        path: MANAGE_REPORTS_ROUTES.MISSED_RMD_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Force Out",
    subNav: [
      {
        id: "forceOutReport",
        label: "Force Out",
        path: MANAGE_REPORTS_ROUTES.FORCE_OUT_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
  {
    label: "Loan Repayment detail",
    subNav: [
      {
        id: "loanRepaymentDetailReport",
        label: "Loan Repayment detail Report",
        path: MANAGE_REPORTS_ROUTES.LOAN_REPAYMENT_DETAIL_REPORT,
        contentHeader: "Reports",
        breadCrumbs: [],
        childRoutes: [],
      },
    ],
    breadCrumbs: [],
    childRoutes: [],
  },
];

export const ALL_MANAGE_REPORTS_ROUTES = [
  ...MANAGE_REPORTS_MENU,
  {
    id: "eligibilityReports",
    contentHeader: "Reports",
    path: MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER,
    breadCrumbs: [
      // {
      //   label: "Manage Reports",
      //   link: MANAGE_REPORTS_ROUTES.ELIGIBILITY_FILTER,
      // },
    ],
  },
];

export const manageReportsFormNames = {
  ELIGIBILITY_FILTER: "eligibility filter",
  NON_PAY_PERIOD_REPORT: "non pay period report",
  GCONTRIBUTION_LIMITS: "gcontribution limit",
  CONTRIBUTION_LIMITS: "contribution limit",
  ELIGIBILITY_FORECAST: "eligibility forecast",
  PLAN_ELIGIBILITY_DATA: "plan eligibility",
  DELETED_PARTICIPANT: "deleted participant",
  REHIRE_REPORT: "rehire report",
  NEW_PARTICIPANT: "new participant",
  EMPLOYEMENT_STATUS: "employement status",
  ERROR_COUNT: "error count",
  LOAN_PAYMENT: "loan payment",
  CONTRIBUTION_DATA_REPORT: "contribution Data report",
  PARTICIPANT_UPDATE_DATA_REPORT: "participant update data report",
  CONTRIBUTION_FLAGS_REPORT: "contribution flags report",
  SPONSOR_DETAILS: "sponsor details",
  PLAN_SUMMARY: "plan summary",
  COMP_HOURS_LOANS_REPORT: "comp hours loans report",
  PERIODIC_CENSUS: "periodic census",
  PERIODIC_EMPLOYER_CONTRIBUTION_REPORT:
    "periodic employer contribution report",
  AGGREGATED_REPORT: "aggregated report",
  RMD_REPORT: "RMD report",
  MISSED_RMD_REPORT: "Missed RMD report",
  FORCE_OUT_REPORT: "force out report",
  FORFEITURE_REPORTS: "forfeiture report",
  VESTING_REDUCTION_REPORT: "vesting reduction report",
  LOAN_REPAYMENT_DETAIL_REPORT: "loan repayment detail report",
  PAYROLL_WORKLOAD_ANTICIPATION_REPORT: "payroll workload",
  PLAN_LIST_REPORT: "plan list",
  ENROLLMENT_REVIEW: "enrollment review",
  REPORT_316_CENSUS: "316 census",
  PAYROLL_CALENDAR_ENDDATE: "payroll calendar end date",
  MAPPER_LIST_REPORT: "mapper list",
  PAYROLL_FREQUENCY_REPORT: "payroll frequency report"
};

export const reportsFormFields = {
  [manageReportsFormNames.NON_PAY_PERIOD_REPORT]: {
    companyId: "companyId",
    planId: "planId",
    rkPlanNumber: "rkPlanNumber",
    planName: "planName",
    allocationSource: "allocationSource",
    allocationSourceId: "allocationSourceId",
    allocationCalculationPeriod: "allocationCalculationPeriod",
    planYear: "planYear",
    startDate: "startDate",
    endDate: "endDate",
    semiAnnualPeriod: "semiAnnualPeriod",
    semiAnnualPeriodId: "semiAnnualPeriodId",
    quarter: "quarter",
    quarterId: "quarterId",
    month: "month",
    monthId: "monthId",
    sourceId: "sourceId",
    companyName: "companyName",
    fromDate: "fromDate",
    toDate: "toDate",
    sourceCategory: "sourceCategory",
    allocationPeriodId: "allocationPeriodId",
  },

  [manageReportsFormNames.LOAN_PAYMENT]: {
    nameOrSsn: "nameOrSsn",
    companyName: "companyName",
    companyId: "companyId",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    planId: "planId",
    planName: "planName",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    payrollPaidDateFrom: "payrollPaidDateFrom",
    payrollPaidDateTo: "payrollPaidDateTo",
    planYearStartDateFrom: "planYearStartDateFrom",
    planYearStartDateTo: "planYearStartDateTo",
    planYearEndDateFrom: "planYearEndDateFrom",
    planYearEndDateTo: "planYearEndDateTo",
    totalLoanRepaymentFrom: "totalLoanRepaymentFrom",
    totalLoanRepaymentTo: "totalLoanRepaymentTo",
    yTDLoanRepaymentFrom: "yTDLoanRepaymentFrom",
    yTDLoanRepaymentTo: "yTDLoanRepaymentTo",
    planGroupNames: "planGroupNames",
  },
  [manageReportsFormNames.CONTRIBUTION_FLAGS_REPORT]: {
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    planYearStartDateFrom: "planYearStartDateFrom",
    planYearStartDateTo: "planYearStartDateTo",
    planYearEndDateFrom: "planYearEndDateFrom",
    planYearEndDateTo: "planYearEndDateTo",
    fileName: "fileName",
    activeEEsFrom: "activeEEsFrom",
    activeEEsTo: "activeEEsTo",
    terminatedEmployeesFrom: "terminatedEmployeesFrom",
    terminatedEmployeesTo: "terminatedEmployeesTo",
    employeesOverDeferralLimitFrom: "employeesOverDeferralLimitFrom",
    employeesOverDeferralLimitTo: "employeesOverDeferralLimitTo",
    eligibleButNotDeferringFrom: "eligibleButNotDeferringFrom",
    eligibleButNotDeferringTo: "eligibleButNotDeferringTo",
    inEligibleMatchFrom: "inEligibleMatchFrom",
    inEligibleMatchTo: "inEligibleMatchTo",
    payPeriodMatchGreaterThanDeferralFrom:
      "payPeriodMatchGreaterThanDeferralFrom",
    payPeriodMatchGreaterThanDeferralTo: "payPeriodMatchGreaterThanDeferralTo",
    matchButNoDeferralFrom: "matchButNoDeferralFrom",
    matchButNoDeferralTo: "matchButNoDeferralTo",
    inEligiblePretaxContributionsFrom: "inEligiblePretaxContributionsFrom",
    inEligiblePretaxContributionsTo: "inEligiblePretaxContributionsTo",
    inEligibleRothContributionsFrom: "inEligibleRothContributionsFrom",
    inEligibleRothContributionsTo: "inEligibleRothContributionsTo",
    inEligiblePretaxCatchUpContributionsFrom:
      "inEligiblePretaxCatchUpContributionsFrom",
    inEligiblePretaxCatchUpContributionsTo:
      "inEligiblePretaxCatchUpContributionsTo",
    inEligibleRothCatchUpContributionsFrom:
      "inEligibleRothCatchUpContributionsFrom",
    inEligibleRothCatchUpContributionsTo:
      "inEligibleRothCatchUpContributionsTo",
    inEligibleAfterTaxContributionsFrom: "inEligibleAfterTaxContributionsFrom",
    inEligibleAfterTaxContributionsTo: "inEligibleAfterTaxContributionsTo",
    fileStatus: "fileStatus",
    planGroupNames: "planGroupNames",
  },
  [manageReportsFormNames.COMP_HOURS_LOANS_REPORT]: {
    nameOrSsn: "nameOrSsn",
    companyName: "companyName",
    rkPlanNumber: "rkPlanNumber",
    companyId: "companyId",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    planId: "planId",
    planName: "planName",
    rkPlanNumber: "rkPlanNumber",
    amountFrom: "amountFrom",
    amountTo: "amountTo",
    fromDate: "fromDate",
    toDate: "toDate",
    payrollDateFrom: "payrollDateFrom",
    payrollDateTo: "payrollDateTo",
    ssn: "ssn",
    planYearStartFrom: "planYearStartFrom",
    planYearStartTo: "planYearStartTo",
    planYearEndFrom: "planYearEndFrom",
    planYearEndTo: "planYearEndTo",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    payPeriodPlanCompensationFrom: "payPeriodPlanCompensationFrom",
    payPeriodPlanCompensationTo: "payPeriodPlanCompensationTo",
    ytdGrossCompensationFileFrom: "ytdGrossCompensationFileFrom",
    ytdGrossCompensationFileTo: "ytdGrossCompensationFileTo",
    ytdGrossCompensationFile: "ytdGrossCompensationFile",
    ytdGrossCompensationCalculated: "ytdGrossCompensationCalculated",
    yTDGrossCompensationCalculatedFrom: "yTDGrossCompensationCalculatedFrom",
    yTDGrossCompensationCalculatedTo: "yTDGrossCompensationCalculatedTo",
    ytdPlanEligibleCompensationFile: "ytdPlanEligibleCompensationFile",
    ytdPlanEligibleCompensationFileFrom: "ytdPlanEligibleCompensationFileFrom",
    ytdPlanEligibleCompensationFileTo: "ytdPlanEligibleCompensationFileTo",
    ytdPlanEligibleCompensationCalculated:
      "ytdPlanEligibleCompensationCalculated",
    ytdPlanEligibleCompensationCalculatedTo:
      "ytdPlanEligibleCompensationCalculatedTo",
    ytdPlanEligibleCompensationCalculatedFrom:
      "ytdPlanEligibleCompensationCalculatedFrom",
    payPeriodHoursFrom: "payPeriodHoursFrom",
    payPeriodHoursTo: "payPeriodHoursTo",
    payPeriodHours: "payPeriodHours",
    payPeriodHoursEquivalency: "payPeriodHoursEquivalency",
    yTDHoursFileFrom: "yTDHoursFileFrom",
    yTDHoursFileTo: "ytdHoursFileTo",
    ytdHoursFile: "ytdHoursFile",
    ytdHoursCalculatedFrom: "ytdHoursCalculatedFrom",
    ytdHoursCalculatedTo: "ytdHoursCalculatedTo",
    ytdHoursEquivalencyTo: "ytdHoursEquivalencyTo",
    ytdHoursEquivalencyFrom: "ytdHoursEquivalencyFrom",
    anniversaryHourstoDateFrom: "anniversaryHourstoDateFrom",
    anniversaryHourstoDateTo: "anniversaryHourstoDateTo",
    priorYearCensusHoursFrom: "priorYearCensusHoursFrom",
    priorYearCensusHoursTo: "priorYearCensusHoursTo",
    yTDGrossCompensationPriortoEligibilityTo:
      "yTDGrossCompensationPriortoEligibilityTo",
    yTDGrossCompensationPriortoEligibilityFrom:
      "yTDGrossCompensationPriortoEligibilityFrom",
    payPeriodLoanRepaymentFrom: "payPeriodLoanRepaymentFrom",
    payPeriodLoanRepaymentTo: "payPeriodLoanRepaymentTo",
    ytdLoanRepaymentFrom: "ytdLoanRepaymentFrom",
    ytdLoanRepaymentTo: "ytdLoanRepaymentTo",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.PLAN_ELIGIBILITY_DATA]: {
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    planGroup: "planGroup",
    latestPayrollDateFrom: "latestPayrollDateFrom",
    latestPayrollDateTo: "latestPayrollDateTo",
    planYearStartFrom: "planYearStartFrom",
    planYearStartTo: "planYearStartTo",
    planYearEndFrom: "planYearEndFrom",
    PlanYearEndTo: "planYearEndTo",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    age: "age",
    employeeClassification: "employeeClassification",
    clientEligibility: "clientEligibility",
    workEmailAddress: "workEmailAddress",
    address1: "address1",
    address2: "address2",
    city: "city",
    state: "state",
    country: "country",
    zipCode: "zipCode",
    originalHireDateFrom: "originalHireDateFrom",
    originalHireDateTo: "originalHireDateTo",
    dateChangeInHireDate: "dateChangeInHireDate",
    changedHireDateFrom: "changedHireDateFrom",
    changedHireDateTo: "changedHireDateTo",
    termDate1From: "termDate1From",
    termDate1To: "termDate1To",
    hireDate1From: "hireDate1From",
    hireDate1To: "hireDate1To",
    termDate2From: "termDate2From",
    termDate2To: "termDate2To",
    hireDate2From: "hireDate2From",
    hireDate2To: "hireDate2To",
    termDate3From: "termDate3From",
    termDate3To: "termDate3To",
    hireDate3From: "hireDate3From",
    hireDate3To: "hireDate3To",
    termDate4From: "termDate4From",
    termDate4To: "termDate4To",
    hireDate4From: "hireDate4From",
    hireDate4To: "hireDate4To",
    termDate5From: "termDate5From",
    termDate5To: "termDate5To",
    hireDate5From: "hireDate5From",
    hireDate5To: "hireDate5To",
    termDate6From: "termDate6From",
    termDate6To: "termDate6To",
    hireDate6From: "hireDate6From",
    hireDate6To: "hireDate6To",
    termDate7From: "termDate7From",
    termDate7To: "termDate7To",
    hireDate7From: "hireDate7From",
    hireDate7To: "hireDate7To",
    termDate8From: "termDate8From",
    termDate8To: "termDate8To",
    hireDate8From: "hireDate8From",
    hireDate8To: "hireDate8To",
    termDate9From: "termDate9From",
    termDate9To: "termDate9To",
    hireDate9From: "hireDate9From",
    hireDate9To: "hireDate9To",
    termDate10From: "termDate10From",
    termDate10To: "termDate10To",
    hireDate10From: "hireDate10From",
    hireDate10To: "hireDate10To",
    currentlyEmployeed: "currentlyEmployeed",
    upcomingEntry: "upcomingEntry",
    hoursInPayrollFile: "hoursInPayrollFile",
    yTDHours: "yTDHours",
    eligibleForPreTax: "eligibleForPreTax",
    eligibilityCriteriaForPreTax: "eligibilityCriteriaForPreTax",
    preTaxEligibilityRequirementMetDateFrom:
      "preTaxEligibilityRequirementMetDateFrom",
    preTaxEligibilityRequirementMetDateTo:
      "preTaxEligibilityRequirementMetDateTo",
    entryDateForPreTaxFrom: "entryDateForPreTaxFrom",
    entryDateForPreTaxTo: "entryDateForPreTaxTo",
    eligibleForRoth: "eligibleForRoth",
    eligibilityCriteriaForRoth: "eligibilityCriteriaForRoth",
    rothEligibilityRequirementMetDateFrom:
      "rothEligibilityRequirementMetDateFrom",
    rothEligibilityRequirementMetDateTo: "rothEligibilityRequirementMetDateTo",
    entryDateForRothFrom: "entryDateForRothFrom",
    entryDateForRothTo: "entryDateForRothTo",
    eligibleForSafeHarborMatch: "eligibleForSafeHarborMatch",
    entryDateForSafeHarborMatchFrom: "entryDateForSafeHarborMatchFrom",
    entryDateForSafeHarborMatchTo: "entryDateForSafeHarborMatchTo",
    eligibleForSafeHarborNonElective: "eligibleForSafeHarborNonElective",
    entryDateForSafeHarborNonElectiveFrom:
      "entryDateForSafeHarborNonElectiveFrom",
    entryDateForSafeHarborNonElectiveTo: "ntryDateForSafeHarborNonElectiveTo",
    eligibleForProfitSharing: "eligibleForProfitSharing",
    entryDateForProfitSharingFrom: "entryDateForProfitSharingFrom",
    entryDateForProfitSharingTo: "entryDateForProfitSharingTo",
    eligibleForMatch: "eligibleForMatch",
    entryDateForMatchFrom: "entryDateForMatchFrom",
    entryDateForMatchTo: "entryDateForMatchTo",
    eligibleForPrevailingWages: "eligibleForPrevailingWages",
    entryDateForPrevailingWagesFrom: "entryDateForPrevailingWagesFrom",
    entryDateForPrevailingWagesTo: "entryDateForPrevailingWagesTo",
    eligibleForQMAC: "eligibleForQMAC",
    entryDateForQMACFrom: "entryDateForQMACFrom",
    entryDateForQMACTo: "entryDateForQMACTo",
    eligibleForQNEC: "eligibleForQNEC",
    entryDateForQNECFrom: "entryDateForQNECFrom",
    entryDateForQNECTo: "entryDateForQNECTo",
    rehireDateExists: "rehireDateExists",
    planEntryDateandRehireDateinEligibility:
      "planEntryDateandRehireDateinEligibility",
    planEntryDateLessthanRehireDateinEligibility:
      "planEntryDateLessthanRehireDateinEligibility",
    fiveYearBreakinService: "fiveYearBreakinService",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.ELIGIBILITY_FILTER]: {
    search: "search",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planGroup: "planGroup",
    planName: "planName",
    eligibilityStatus: "eligibilityStatus",
    planId: "planId",
    planName: "planName",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    clientEligibility: "clientEligibility",
    employmentStatus: "employmentStatus",
    address1: "address1",
    address2: "address2",
    city: "city",
    state: "state",
    country: "country",
    zipCode: "zipCode",
    hireDateFrom: "hireDateFrom",
    hireDateTo: "hireDateTo",
    terminationDateFrom: "terminationDateFrom",
    terminationDateTo: "terminationDateTo",
    rehireDateFrom: "rehireDateFrom",
    rehireDateTo: "rehireDateTo",
    runDateFrom: "runDateFrom",
    runDateTo: "runDateTo",
    entryDateFrom: "entryDateFrom",
    entryDateTo: "entryDateTo",
    eligibilityStatus: "eligibilityStatus",
    sourceName: "sourceName",
    anchorFlag: "anchorFlag",
    eligibilityDateFrom: "eligibilityDateFrom",
    eligibilityDateTo: "eligibilityDateTo",
    reason: "reason",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.GCONTRIBUTION_LIMITS]: {
    nameOrSsn: "nameOrSsn",
    companyName: "companyName",
    companyId: "companyId",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    planId: "planId",
    planName: "planName",
    amountFrom: "amountFrom",
    amountTo: "amountTo",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    payDate: "payDate",
    preTaxTo: "preTaxTo",
    preTaxFrom: "preTaxFrom",
    dateFrom: "dateFrom",
    dateTo: "dateTo",
    ageFrom: "ageFrom",
    ageTo: "ageTo",
    rothFrom: "rothFrom",
    rothTo: "rothTo",
    totalContributionFrom: "totalContributionFrom",
    totalContributionTo: "totalContributionTo",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.PLAN_ELIGIBILITY_DATA]: {
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
  },

  [manageReportsFormNames.CONTRIBUTION_DATA_REPORT]: {
    nameOrSsn: "nameOrSsn",
    companyName: "companyName",
    planName: "planName",
    companyId: "companyId",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    planId: "planId",
    planName: "planName",
    amountFrom: "amountFrom",
    amountTo: "amountTo",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    preTaxTo: "preTaxTo",
    preTaxFrom: "preTaxFrom",
    dateFrom: "dateFrom",
    dateTo: "dateTo",
    ageFrom: "ageFrom",
    ageTo: "ageTo",
    birthDateFrom: "birthDateFrom",
    birthDateTo: "birthDateTo",
    planYearStartFrom: "planYearStartFrom",
    planYearStartTo: "planYearStartTo",
    planYearEndFrom: "planYearEndFrom",
    planYearEndTo: "planYearEndTo",
    birthDateFrom: "birthDateFrom",
    birthDateTo: "birthDateTo",
    currentlyEmployed: "currentlyEmployed",
    hoursFrom: "hoursFrom",
    hoursTo: "hoursTo",
    grossCompensationFrom: "grossCompensationFrom",
    grossCompensationTo: "grossCompensationTo",
    planCompensationFrom: "planCompensationFrom",
    planCompensationTo: "planCompensationTo",
    ineligiblePretax: "ineligiblePretax",
    ineligibleRoth: "ineligibleRoth",
    preTaxFrom: "preTaxFrom",
    preTaxTo: "preTaxTo",
    rothFrom: "rothFrom",
    rothTo: "rothTo",
    totalContributionFrom: "totalContributionFrom",
    totalContributionTo: "totalContributionTo",
    catchupContributionPretaxFrom: "catchupContributionPretaxFrom",
    catchupContributionPretaxTo: "catchupContributionPretaxTo",
    catchupContributionRothFrom: "catchupContributionRothFrom",
    catchupContributionRothTo: "catchupContributionRothTo",
    afterTaxFrom: "afterTaxFrom",
    afterTaxTo: "afterTaxTo",
    employerMatchFrom: "employerMatchFrom",
    employerMatchTo: "employerMatchTo",
    employerProfitSharingFrom: "employerProfitSharingFrom",
    employerProfitSharingTo: "employerProfitSharingTo",
    employerSafeHarborMatchFrom: "employerSafeHarborMatchFrom",
    employerSafeHarborMatchTo: "employerSafeHarborMatchTo",
    employerSafeHarborNonelectiveFrom: "employerSafeHarborNonelectiveFrom",
    employerSafeHarborNonelectiveTo: "employerSafeHarborNonelectiveTo",
    employerPrevailingWageFrom: "employerPrevailingWageFrom",
    employerPrevailingWageTo: "employerPrevailingWageTo",
    employerAdditionalFixedMatchFrom: "employerAdditionalFixedMatchFrom",
    employerAdditionalFixedMatchTo: "employerAdditionalFixedMatchTo",
    employerAdditionalDiscretionaryMatchFrom:
      "employerAdditionalDiscretionaryMatchFrom",
    employerAdditionalDiscretionaryMatchTo:
      "employerAdditionalDiscretionaryMatchTo",
    employerQNECFrom: "employerQNECFrom",
    employerQNECTo: "employerQNECTo",
    employerQMACFrom: "employerQMACFrom",
    employerQMACTo: "employerQMACTo",
    loanRepaymentFrom: "loanRepaymentFrom",
    loanRepaymentTo: "loanRepaymentTo",
    employeeNo: "employeeNo",
  },

  [manageReportsFormNames.PARTICIPANT_UPDATE_DATA_REPORT]: {
    nameOrSsn: "nameOrSsn",
    companyName: "companyName",
    companyId: "companyId",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    planId: "planId",
    rKPlanNumber: "rkPlanNumber",
    masterPlanId: "masterPlanId",
    planName: "planName",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    updatedDateTo: "updatedDateTo",
    updatedDateFrom: "updatedDateFrom",
    updatedAddress1: "updatedAddress1",
    updatedBirthDate: "updatedBirthDate",
    updatedTerminationDate: "updatedTerminationDate",
    updatedEmployeeClassification: "updatedEmployeeClassification",
    updatedPlanEligibilityDate: "updatedPlanEligibilityDate",
    updatedPlanEntryDate: "updatedPlanEntryDate",
    updatedPreTaxEligibilityDate: "updatedPreTaxEligibilityDate",
    updatedRothEligibilityDate: "updatedRothEligibilityDate",
    updatedPretaxCatchupEligibilityDate: "updatedPretaxCatchupEligibilityDate",
    updatedRothCatchupEligibilityDate: "updatedRothCatchupEligibilityDate",
    updatedAftertaxEligibilityDate: "updatedAftertaxEligibilityDate",
    updatedMatchEligibilityDate: "updatedMatchEligibilityDate",
    updatedSafeHarborMatchEligibilityDate:
      "updatedSafeHarborMatchEligibilityDate",
    updatedSafeHarborNonElectiveEligibilityDate:
      "updatedSafeHarborNonElectiveEligibilityDate",
    updatedProfitSharingEligibilityDate: "updatedProfitSharingEligibilityDate",
    updatedPrevailingWagesEligibilityDate:
      "updatedPrevailingWagesEligibilityDate",
    updatedQMACEligibilityDate: "updatedQMACEligibilityDate",
    updatedQNECEligibilityDate: "updatedQNECEligibilityDate",
    employeeNo: "employeeNo",
  },

  [manageReportsFormNames.FORFEITURE_REPORTS]: {
    companyName: "companyName",
    companyId: "companyId",
    planName: "planName",
    planId: "planId",
    sponsorOrganizationName: "sponsorOrganizationName",
    sponsorOrganizationId: "sponsorOrganizationId",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    forfeitureEvent: "forfeitureEvent",
    status: "status",
    nameOrSsn: "nameOrSsn",
  },

  [manageReportsFormNames.VESTING_REDUCTION_REPORT]: {
    companyId: "companyId",
    planId: "planId",
    sponsorOrganizationId: "sponsorOrganizationId",
    startDate: "startDate",
    endDate: "endDate",
    employeeNameOrSsn: "employeeNameOrSsn",
    rkPlanNumber: "rkPlanNumber",
    uniquePersonalIdentification: "uniquePersonalIdentification",
    firstName: "firstName",
    lastName: "lastName",
    sourcename: "sourcename",
    previousYOSFrom: "previousYOSFrom",
    previousYOSTo: "previousYOSTo",
    updatedYOSFrom: "updatedYOSFrom",
    updatedYOSTo: "updatedYOSTo",
    previousVestedPercentageFrom: "previousVestedPercentageFrom",
    previousVestedPercentageTo: "previousVestedPercentageTo",
    updatedVestedPercentageFrom: "updatedVestedPercentageFrom",
    updatedVestedPercentageTo: "updatedVestedPercentageTo",
    runDateFrom: "runDateFrom",
    runDateTo: "runDateTo",
  },

  [manageReportsFormNames.CONTRIBUTION_LIMITS]: {
    nameOrSsn: "nameOrSsn",
    companyName: "companyName",
    companyId: "companyId",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    planId: "planId",
    planName: "planName",
    amountFrom: "amountFrom",
    amountTo: "amountTo",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    payDate: "payDate",
    preTaxTo: "preTaxTo",
    preTaxFrom: "preTaxFrom",
    afterTaxTo: "afterTaxTo",
    afterTaxFrom: "afterTaxFrom",
    matchFrom: "matchFrom",
    matchTo: "matchTo",
    nonElectiveFrom: "nonElectiveFrom",
    nonElectiveTo: "nonElectiveTo",
    RothFrom: "RothFrom",
    RothTo: "RothTo",
    TotalContributionFrom: "TotalContributionFrom",
    TotalContributionTo: "TotalContributionFrom",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.ELIGIBILITY_FORECAST]: {
    search: "search",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planGroup: "planGroup",
    planName: "planName",
    asOfDate: "asOfDate",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    employmentStatus: "employmentStatus",
    address1: "address1",
    address2: "address2",
    city: "city",
    state: "state",
    country: "country",
    zipCode: "zipCode",
    hireDateFrom: "hireDateFrom",
    hireDateTo: "hireDateTo",
    terminationDateFrom: "terminationDateFrom",
    terminationDateTo: "terminationDateTo",
    rehireDateFrom: "rehireDateFrom",
    rehireDateTo: "rehireDateTo",
    sourceName: "sourceName",
    requirementMetDateFrom: "requirementMetDateFrom",
    requirementMetDateTo: "requirementMetDateTo",
    forecastedEntryDateFrom: "forecastedEntryDateFrom",
    forecastedEntryDateTo: "forecastedEntryDateTo",
    forecastedEntryDate: "forecastedEntryDate",
    eligibilityCriteria: "eligibilityCriteria",
    employeeNo: "employeeNo",
    transactionDateFrom: "transactionDateFrom",
    transactionDateTo: "transactionDateFrom",
    equivalencyHoursFrom: "equivalencyHoursFrom",
    equivalencyHoursTo: "equivalencyHoursTo",
    priorYearsActualHoursFrom: "priorYearsActualHoursFrom",
    priorYearsActualHoursTo: "priorYearsActualHoursTo",
    accumulatedHoursFrom: "accumulatedHoursFrom",
    accumulatedHoursTo: "accumulatedHoursTo",
    employeeClassification: "employeeClassification",
    rKPlanNumber: "rKPlanNumber",
  },
  [manageReportsFormNames.ENROLLMENT_REVIEW]: {
    search: "search",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    employmentStatus: "employmentStatus",
    address1: "address1",
    address2: "address2",
    city: "city",
    state: "state",
    country: "country",
    zipCode: "zipCode",
    hireDateFrom: "hireDateFrom",
    hireDateTo: "hireDateTo",
    terminationDateFrom: "terminationDateFrom",
    terminationDateTo: "terminationDateTo",
    rehireDateFrom: "rehireDateFrom",
    rehireDateTo: "rehireDateTo",
    sourceName: "sourceName",
    ltptEligibility: "ltptEligibility",
    hoursRequirementMet: "hoursRequirementMet",
    EntryDateFrom: "forecastedEntryDateFrom",
    EntryDateTo: "forecastedEntryDateTo",
    EntryDate: "forecastedEntryDate",
    accumulatedHoursFrom: "accumulatedHoursFrom",
    accumulatedHoursTo: "accumulatedHoursTo",
    employeeClassification: "employeeClassification",
    rKPlanNumber: "rKPlanNumber",
  },
  [manageReportsFormNames.DELETED_PARTICIPANT]: {
    nameOrSsn: "nameOrSsn",
    companyId: "companyId",
    companyName: "companyName",
    fromDate: "fromDate",
    toDate: "toDate",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    deletedBy: "deletedBy",
    deletedDateAndTimeFrom: "deletedDateAndTimeFrom",
    deletedDateAndTimeTo: "deletedDateAndTimeTo",
  },
  [manageReportsFormNames.REHIRE_REPORT]: {
    nameOrSsn: "nameOrSsn",
    companyId: "companyId",
    companyName: "companyName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    fromDate: "fromDate",
    toDate: "toDate",
    planId: "planId",
    planName: "planName",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    planId: "planId",
    planName: "planName",
    employmentStatus: "employmentStatus",
    dateOfHireFrom: "dateOfHireFrom",
    dateOfHireTo: "dateOfHireTo",
    recentTerminationDateFrom: "recentTerminationDateFrom",
    recentTerminationDateTo: "recentTerminationDateTo",
    recentRehireDateFrom: "recentRehireDateFrom",
    recentRehireDateTo: "recentRehireDateTo",
    eligibilityRequirementMetDateFrom: "eligibilityRequirementMetDateFrom",
    eligibilityRequirementMetDateTo: "eligibilityRequirementMetDateTo",
    eligibilityStatus: "eligibilityStatus",
    employeeClassification: "employeeClassification",
    planEntryDateFrom: "planEntryDateFrom",
    planEntryDateTo: "planEntryDateTo",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.NEW_PARTICIPANT]: {
    nameOrSsn: "nameOrSsn",
    companyId: "companyId",
    companyName: "companyName",
    fromDate: "fromDate",
    toDate: "toDate",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    planId: "planId",
    planName: "planName",
    newToPlan: "newToPlan",
    eligibilityStatus: "eligibilityStatus",
    employeeClassification: "employeeClassification",
    address1: "address1",
    address2: "address2",
    address3: "address3",
    city: "city",
    state: "state",
    zipCode: "zipCode",
    email: "email",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    dateOfHireFrom: "dateOfHireFrom",
    dateOfHireTo: "dateOfHireTo",
    terminationDateFrom: "terminationDateFrom",
    terminationDateTo: "terminationDateTo",
    recentRehireDateFrom: "recentRehireDateFrom",
    recentRehireDateTo: "recentRehireDateTo",
    ineligibleSource: "ineligibleSource",
  },
  [manageReportsFormNames.EMPLOYEMENT_STATUS]: {
    nameOrSsn: "nameOrSsn",
    companyId: "companyId",
    companyName: "companyName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    fromDate: "fromDate",
    planId: "planId",
    planName: "planName",
    ssn: "ssn",
    firstName: "firstName",
    lastName: "lastName",
    dateOfBirth: "dateOfBirth",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    priorStatus: "priorStatus",
    updatedStatus: "updatedStatus",
    updatededDate: "updatededDate",
    updatedDateTimeFrom: "updatedDateTimeFrom",
    updatedDateTimeTo: "updatedDateTimeTo",
    employeeNo: "employeeNo",
  },

  [manageReportsFormNames.ERROR_COUNT]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    planId: "planId",
    planName: "planName",
    payDateFrom: "payDateFrom",
    planGroupNames: "planGroupNames",
    payDateTo: "payDateTo",
    fileName: "fileName",
    numberOfHardErrors: "numberOfHardErrors",
    numberOfSoftErrors: "numberOfSoftErrors",
  },
  [manageReportsFormNames.SPONSOR_DETAILS]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorName: "sponsorName",
    firstName: "firstName",
    lastName: "lastName",
    userName: "userName",
    sponsorSSN: "sponsorSSN",
    registrationDateFrom: "registrationDateFrom",
    registrationDateTo: "registrationDateTo",
    firstLoginDateFrom: "firstLoginDateFrom",
    firstLoginDateTo: "firstLoginDateTo",
    lastLoginDateFrom: "lastLoginDateFrom",
    lastLoginDateTo: "lastLoginDateTo",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    nameOrSsn: "nameOrSsn",
  },
  [manageReportsFormNames.PLAN_SUMMARY]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    sponsorName: "sponsorName",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    noOfParticipants: "noOfParticipants",
    fileName: "fileName",
    planGroupNames: "planGroupNames",
    totalPreTaxFrom: "totalPreTaxFrom",
    totalPreTaxTo: "totalPreTaxTo",
    totalRothFrom: "totalRothFrom",
    totalRothTo: "totalRothTo",
    totalMatchFrom: "totalMatchFrom",
    totalMatchTo: "totalMatchTo",
    totalProfitSharingFrom: "totalProfitSharingFrom",
    totalProfitSharingTo: "totalProfitSharingTo",
    totalSafeHarborFrom: "totalSafeHarborFrom",
    totalSafeHarborTo: "totalSafeHarborTo",
    totalQMACFrom: "totalQMACFrom",
    totalQMACTo: "totalQMACTo",
    totalERSafeHarborNonmatchNonElectiveFrom:
      "totalERSafeHarborNonmatchNonElectiveFrom",
    totalERSafeHarborNonmatchNonElectiveTo:
      "totalERSafeHarborNonmatchNonElectiveTo",
    totalLoanRepaymentAmountFrom: "totalLoanRepaymentAmountFrom",
    totalLoanRepaymentAmountTo: "totalLoanRepaymentAmountTo",
    fileTotalFrom: "fileTotalFrom",
    fileTotalTo: "fileTotalTo",
    totalCompensationFrom: "totalCompensationFrom",
    totalCompensationTo: "totalCompensationTo",
    totalQNECFrom: "totalQNECFrom",
    totalQNECTo: "totalQNECTo",
    rkPlanNumber: "rkPlanNumber",
  },
  [manageReportsFormNames.LATE_PAYROLL_NOTIFICATIONS]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    planGroupNames: "planGroupNames",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    payrollFrequency: "payrollFrequency",
    planYearEndFrom: "planYearEndFrom",
    planYearEndTo: "planYearEndTo",
    delayedPayrollDateFrom: "delayedPayrollDateFrom",
    delayedPayrollDateTo: "delayedPayrollDateTo",
    noOfNotificationsSentFrom: "noOfNotificationsSentFrom",
    noOfNotificationsSentTo: "noOfNotificationsSentTo",
    sponsorName: "sponsorName",
    sponsorEmail: "sponsorEmail",
    latePayrollNotificationsEnabled: "latePayrollNotificationsEnabled",
    latePayrollNotificationsEnabledID: "latePayrollNotificationsEnabledID",
  },
  [manageReportsFormNames.PERIODIC_CENSUS]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    rkPlanNumber: "rkPlanNumber",
    planName: "planName",
    planGroups: "planGroups",
    firstName: "firstName",
    middleInitial: "middleInitial",
    lastName: "lastName",
    ssn: "ssn",
    gender: "gender",
    address1: "address1",
    address2: "address2",
    city: "city",
    state: "state",
    zipCode: "zipCode",
    country: "country",
    birthDateFrom: "birthDateFrom",
    birthDateTo: "birthDateTo",
    hireDateFrom: "hireDateFrom",
    hireDateTo: "hireDateTo",
    terminationDateFrom: "terminationDateFrom",
    terminationDateTo: "terminationDateTo",
    rehireDateFrom: "rehireDateFrom",
    rehireDateTo: "rehireDateTo",
    divisionOrLocation: "divisionOrLocation",
    excludedClassification: "excludedClassification",
    employeeStatus: "employeeStatus",
    unionEmployee: "unionEmployee",
    officer: "officer",
    hoursFrom: "hoursFrom",
    hoursTo: "hoursTo",
    grossCompensationFrom: "grossCompensationFrom",
    grossCompensationTo: "grossCompensationTo",
    postEntryPlanCompensation: "postEntryPlanCompensation",
    postEntryPlanCompensationFrom: "postEntryPlanCompensationFrom",
    postEntryPlanCompensationTo: "postEntryPlanCompensationTo",
    planCompensationFrom: "planCompensationFrom",
    planCompensationTo: "planCompensationTo",
    pretaxFrom: "pretaxFrom",
    pretaxTo: "pretaxTo",
    aftertaxFrom: "aftertaxFrom",
    aftertaxTo: "aftertaxTo",
    rothFrom: "rothFrom",
    rothTo: "rothTo",
    pretaxCatchupFrom: "pretaxCatchupFrom",
    pretaxCatchupTo: "pretaxCatchupTo",
    rothCatchupFrom: "rothCatchupFrom",
    rothCatchupTo: "rothCatchupTo",
    employerMatchFrom: "employerMatchFrom",
    employerMatchTo: "employerMatchTo",
    employerDiscretionaryFrom: "employerDiscretionaryFrom",
    employerDiscretionaryTo: "employerDiscretionaryTo",
    employerPrevailingWagesFrom: "employerPrevailingWagesFrom",
    employerPrevailingWagesTo: "employerPrevailingWagesTo",
    safeHarbourMatchFrom: "safeHarbourMatchFrom",
    safeHarbourMatchTo: "safeHarbourMatchTo",
    safeHarbourNonElectiveFrom: "safeHarbourNonElectiveFrom",
    safeHarbourNonElectiveTo: "safeHarbourNonElectiveTo",
    qmacFrom: "qmacFrom",
    qmacTo: "qmacTo",
    qnecFrom: "qnecFrom",
    qnecTo: "qnecTo",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.REPORT_316_CENSUS]: {
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    firstName: "firstName",
    middleInitial: "middleInitial",
    lastName: "lastName",
    ssn: "ssn",
    gender: "gender",
    birthDateFrom: "birthDateFrom",
    birthDateTo: "birthDateTo",
    hireDateFrom: "hireDateFrom",
    hireDateTo: "hireDateTo",
    terminationDateFrom: "terminationDateFrom",
    terminationDateTo: "terminationDateTo",
    rehireDateFrom: "rehireDateFrom",
    rehireDateTo: "rehireDateTo",
    divisionOrLocation: "divisionOrLocation",
    excludedJobClassification: "excludedJobClassification",
    employeeStatusChange: "employeeStatusChange",
    unionEmployee: "unionEmployee",
    leasedEmployee: "leasedEmployee",
    hoursFrom: "hoursFrom",
    hoursTo: "hoursTo",
    grossCompensationFrom: "grossCompensationFrom",
    grossCompensationTo: "grossCompensationTo",
    postEntryPlanCompensation: "postEntryPlanCompensation",
    postEntryPlanCompensationFrom: "postEntryPlanCompensationFrom",
    postEntryPlanCompensationTo: "postEntryPlanCompensationTo",
    pretaxFrom: "pretaxFrom",
    pretaxTo: "pretaxTo",
    aftertaxFrom: "aftertaxFrom",
    aftertaxTo: "aftertaxTo",
    rothFrom: "rothFrom",
    rothTo: "rothTo",
    otherEmployeeContributionFrom: "otherEmployeeContributionFrom",
    otherEmployeeContributionTo: "otherEmployeeContributionTo",
    employerMatchContributionFrom: "employerMatchContributionFrom",
    employerMatchContributionTo: "employerMatchContributionTo",
    employerOtherContributionFrom: "employerOtherContributionFrom",
    employerOtherContributionTo: "employerOtherContributionTo",
    employerSafeHarborContributionFrom: "employerSafeHarborContributionFrom",
    employerSafeHarborContributionTo: "employerSafeHarborContributionTo",
    employerMatchContributionFrom: "employerMatchContributionFrom",
    employerMatchContributionTo: "employerMatchContributionTo",
    employerMatchContributionFrom: "employerMatchContributionFrom",
    employerMatchContributionTo: "employerMatchContributionTo",
    excludedCompensationFringeFrom: "excludedCompensationFringeFrom",
    excludedCompensationFringeTo: "excludedCompensationFringeTo",
    excludedCompensationBonusFrom: "excludedCompensationBonusFrom",
    excludedCompensationBonusTo: "excludedCompensationBonusTo",
    excludedCompensationOvertimeFrom: "excludedCompensationOvertimeFrom",
    excludedCompensationOvertimeTo: "excludedCompensationOvertimeTo",
    unionEmployee: "unionEmployee",
    excludedCompensationCommission: "excludedCompensationCommission",
    excludedCompensationOtherFrom: "excludedCompensationOtherFrom",
    excludedCompensationOtherTo: "excludedCompensationOtherTo",
    severanceCompensationFrom: "severanceCompensationFrom",
    severanceCompensationto: "severanceCompensationTo",
    ltpt: "ltpt"
  },

  [manageReportsFormNames.PAYROLL_CALENDAR_ENDDATE]: {
    EndDateFrom: "EndDateFrom",
    EndDateTo: "EndDateTo",
  },
  [manageReportsFormNames.PERIODIC_EMPLOYER_CONTRIBUTION_REPORT]: {
    search: "search",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    rkPlanNumber: "rkPlanNumber",
    planName: "planName",
    planGroups: "planGroups",
    firstName: "firstName",
    lastName: "lastName",
    ssn: "ssn",
    totalCompensationFrom: "totalCompensationFrom",
    totalCompensationTo: "totalCompensationTo",
    totalDeferralsFrom: "totalDeferralsFrom",
    totalDeferralsTo: "totalDeferralsTo",
    contributionInSystemFrom: "contributionInSystemFrom",
    contributionInSystemTo: "contributionInSystemTo",
    calculatedContributionFrom: "calculatedContributionFrom",
    calculatedContributionTo: "calculatedContributionTo",
    netContributionFrom: "netContributionFrom",
    netContributionTo: "netContributionTo",
    employeeNo: "employeeNo",
  },
  [manageReportsFormNames.AGGREGATED_REPORT]: {
    fromDate: "fromDate",
    toDate: "toDate",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    rkPlanNumber: "rkPlanNumber",
    planName: "planName",
    planGroups: "planGroups",
    groupBy: "groupBy",
  },
  [manageReportsFormNames.RMD_REPORT]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    sponsorName: "sponsorName",
    SSN: "SSN",
    participantName: "participantName",
    ageFrom: "ageFrom",
    ageTo: "ageTo",
    dateOfBirthFrom: "dateOfBirthFrom",
    dateOfBirthTo: "dateOfBirthTo",
    accountBalanceFrom: "accountBalanceFrom",
    accountBalanceTo: "accountBalanceTo",
    RMDDateFrom: "RMDDateFrom",
    RMDDateTo: "RMDDateTo",
    nextRMDDateFrom: "nextRMDDateFrom",
    nextRMDDateTo: "nextRMDDateTo",
    totalRMDAmountFrom: "totalRMDAmountFrom",
    totalRMDAmountTo: "totalRMDAmountTo",
    distributedAmountFrom: "distributedAmountFrom",
    distributedAmountTo: "distributedAmountTo",
    rmdWithdrawalAmountFrom: "rmdWithdrawalAmountFrom",
    rmdWithdrawalAmountTo: "rmdWithdrawalAmountTo",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
  },
  [manageReportsFormNames.FORCE_OUT_REPORT]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    sponsorOrganizationId: "sponsorOrganizationId",
    sponsorOrganizationName: "sponsorOrganizationName",
    sponsorName: "sponsorName",
    SSN: "SSN",
    participantFirstName: "participantFirstName",
    participantSecondtName: "participantSecondName",
    address1: "address1",
    address2: "address2",
    address3: "address3",
    city: "city",
    state: "state",
    zipCode: "zipCode",
    dateOfBirth: "dateOfBirth",
    dateOfHireFrom: "dateOfHireFrom",
    dateOfHireTo: "dateOfHireTo",
    recentTerminationDateFrom: "recentTerminationDateFrom",
    recentTerminationDateTo: "recentTerminationDateTo",
    accountBalance: "accountBalance",
    forceOutAmount: "forceOutAmount",
    accountBalance: "accountBalance",
    dateAndTime: "dateAndTime",
    payDateFrom: "payDateFrom",
    payDateTo: "payDateTo",
  },
  [manageReportsFormNames.LOAN_REPAYMENT_DETAIL_REPORT]: {
    search: "search",
    companyName: "companyName",
    companyId: "companyId",
    planId: "planId",
    planName: "planName",
    SSN: "SSN",
    loanId: "loanId",
    loanType: "loanType",
    loanTypeLabel: "loanTypeLabel",
    loanStatus: "loanStatus",
    paymentFrequency: "paymentFrequency",
    submittedDate: "submittedDate",
    fromDate: "fromDate",
    toDate: "toDate",

    employeeName: "employeeName",
    interestRate: "interestRate",
    loanTenure: "loanTenure",
    orginalLoanAmount: "originalLoanAmount",
    outstandingPrincipleAmount: "outstandingPrincipleAmount",
    outstandingInterestAmount: "outstandingInterestAmount",
    nameOrSSN: "nameOrSSN",
    originalLoanAmountFrom: "originalLoanAmountFrom",
    originalLoanAmountTo: "originalLoanAmountTo",
    outstandingPrincipleAmountFrom: "outstandingPrincipleAmountFrom",
    outstandingPrincipleAmountTo: "outstandingPrincipleAmountTo",
  },
  [manageReportsFormNames.PAYROLL_WORKLOAD_ANTICIPATION_REPORT]: {
    periodStartDate: "periodStartDate",
    periodEndDate: "periodEndDate",
  },
  [manageReportsFormNames.PLAN_LIST_REPORT]: {
    planStatus: "planStatus",
    planStatusId: "planStatusId",
    createdFrom: "createdFrom",
    createdTo: "createdTo",
  },
  [manageReportsFormNames.MAPPER_LIST_REPORT]: {
    profileType: "profileType",
    profileTypeId: "profileTypeId",
  },
  [manageReportsFormNames.PAYROLL_FREQUENCY_REPORT]: {
    payrollFrequencyType: "payrollFrequencyType",
    payrollFrequencyTypeId: "payrollFrequencyTypeId",
  },
};
